"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TrialsBarchart_vue_1 = __importDefault(require("@becrop/components/Results/Projects/TrialsBarchart.vue"));
const floating_vue_1 = require("floating-vue");
let TableSummary = class TableSummary extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get hasDefaultSorting() {
        return true;
    }
    get zeroMatchesCombination() {
        return this.summaryTable.length === 0 && this.hasAFilterActive;
    }
    omisibleColumn(col) {
        if (this.summaryTable.length < 1) {
            return false;
        }
        else {
            if (this.omisibleColumns.findIndex((c) => c === col) !== -1)
                return true;
            return false;
        }
    }
    chooseSortable(criteria) {
        this.$emit('choosesortable', criteria);
    }
    fixChartValues(cv) {
        if (this.focus === 'Times') {
            return cv.sort((a, b) => parseInt(a.name.match(/\d+/)[0], 10) - parseInt(b.name.match(/\d+/)[0], 10));
        }
        else {
            return cv;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummary.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], TableSummary.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableSummary.prototype, "summaryTable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableSummary.prototype, "products", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableSummary.prototype, "chartCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableSummary.prototype, "dynamicCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableSummary.prototype, "hasAFilterActive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableSummary.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableSummary.prototype, "focus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableSummary.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableSummary.prototype, "omisibleColumns", void 0);
TableSummary = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            TrialsBarchart: TrialsBarchart_vue_1.default,
            Dropdown: floating_vue_1.Dropdown
        },
    })
], TableSummary);
exports.default = TableSummary;
